document.addEventListener('DOMContentLoaded', () => {
    var d4SavedItems = d4SavedItems || [];
    var bundleFlavors, freeProducts;
    let freeProductFunctionCalled = false;
    let d4IsCheckingOut = false; // Flag to block auto-remove during checkout
    const bundleContainer = document.querySelector('.d4-custom-bundle-container');
    const fullBoxMsg = document.querySelector('.d4-custom-bundle-container').dataset.boxFull;
    const mainBundle = document.querySelector('.d4-custom-bundle-container .d4-bundle-flavors .d4-flavor-bundle .d4-flavor-bundle-body');
    const mainBundleEmpty = document.querySelector('.d4-custom-bundle-container .d4-bundle-flavors .d4-flavor-bundle .d4-flavor-bundle-body .d4-flavor-bundle-empty');
    const mobileBundle = document.querySelector('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-bundle');
    const mobileBtn = document.querySelector('.d4-custom-bundle-container .d4-flavor-container .d4-bundle-mobile .d4-bundle-mobile-btn');
    const mobileBtnLabel = mobileBtn.querySelector('h3');
    const mobileBtnQuantity = mobileBtn.querySelector('span');
    const mobileCloseBtn = document.querySelector('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-bundle .d4-flavor-bundle-header .d4-flavor-bundle-mobile-close');
    const checkoutBtn = mainBundle.closest('.d4-flavor-bundle').querySelector('.d4-flavor-bundle-checkout button');
    const checkoutBtnLabel= checkoutBtn.querySelector('h3');
    const checkoutBtnLabelText = checkoutBtn.querySelector('h3').dataset.stickyLabel;
    const checkoutBtnLabelText24 = checkoutBtn.querySelector('h3').dataset.stickyLabel24;
    const checkoutBtnLabelText16 = checkoutBtn.querySelector('h3').dataset.stickyLabel16;
    const checkoutBtnLabelMin = checkoutBtn.querySelector('h3').dataset.stickyMin;
    const checkoutBtnLabelReq = checkoutBtn.querySelector('h3').dataset.stickyRequired;
    const checkoutBtnLabelCp3 = checkoutBtn.querySelector('h3').dataset.stickyCp3 || 'Review Your Box';
    const checkoutBtnLabelBetweenCp2Cp3 = checkoutBtn.querySelector('h3').dataset.stickyBetweenCp2Cp3 || 'Almost there!';
    const checkoutBtnQuantity = checkoutBtn.querySelector('span');

    //Function to change the active class within variants & within options
    const d4HandleBundleVariants = () => {
        const mealVariants = document.querySelectorAll('.d4-custom-bundle-container .d4-options .d4-option-btn');
        var selectedOption = localStorage.getItem('d4-option');
        if(selectedOption === null || selectedOption === undefined) {
            mealVariants[0].classList.add('d4-option-selected');
        } else {
            for(option of mealVariants) {
                if(option.dataset.d4Option === selectedOption) {
                    option.classList.add('d4-option-selected');
                } else {
                    option.classList.remove('d4-option-selected');
                }
            }
        }

        //update active class of the option meals & store the value
        for(variant of mealVariants) {
            variant.addEventListener('click', (e) => {
                mealVariants.forEach(variant => {
                    if(variant !== e.target) {
                        variant.classList.remove('d4-option-selected');
                    }
                });

                e.target.classList.add('d4-option-selected');
                localStorage.setItem('d4-option', e.target.dataset.d4Option);
            });
        };
    };


    //Function to load bundleobject
    const d4LoadbundleObject = () => {
        bundleFlavors = d4BundleObject();
        console.log('bundle object: ', bundleFlavors)
    };

    //Function to load free Products
    const d4LoadFreeProducts = () => {
        freeProducts = d4freeProducts();
        console.log('free products: ', freeProducts)
    };

    //Function to handle the filters changes
    const d4HandleFilterChanges = () => {
        const filterProducts = document.querySelectorAll('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-products .d4-flavor-product');
        const filterCloseBtn = document.querySelector('.d4-custom-bundle-container .d4-flavor-heading .d4-filter-label svg');
        const filterLabel = document.querySelector('.d4-custom-bundle-container .d4-flavor-heading .d4-filter-label span');
        const filterSelect = document.querySelector('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-heading select');

        //function to reset filters
        const d4ResetFilters = () => {
            for(product of filterProducts) {
                product.classList.remove('d4-hide-product');
                if(filterCloseBtn) filterCloseBtn.style.display = 'none';
                if(filterSelect) filterSelect.value = 'All Flavors';
                if(filterLabel) filterLabel.textContent = 'All Flavors';
            }
        }

        //remove all filters
        if(filterCloseBtn) {
            filterCloseBtn.addEventListener('click', () => {
                d4ResetFilters();
            });
        }

        //filter products on changing values
        if(filterSelect) {
            filterSelect.addEventListener('change', (e) => {
                for(product of filterProducts) {
                    if(e.target.value === 'All Flavors') {
                        d4ResetFilters();
                    } else {
                        const target = e.target.value.toLowerCase().split(' ').join('-');
                        if(!product.dataset.filter || !product.dataset.filter.includes(target)) {
                            product.classList.add('d4-hide-product');
                        } else {
                            product.classList.remove('d4-hide-product');
                        }
                        if(filterCloseBtn) filterCloseBtn.style.display = 'block';
                        if(filterLabel) filterLabel.textContent = e.target.value;
                    }
                }
            })
        }
    }


    //Function to add free product
    if(bundleContainer.hasAttribute('data-d4-bundle-free-product')) {
        var d4HandleFreeProduct = () => {
            console.log('free product function called')
            for(product of freeProducts) {
            const elm = document.createElement('div');
            elm.classList.add('d4-free-product-bundled');
            elm.setAttribute('data-bundled-id', product.id);
            const img = document.createElement('img');
            img.classList.add('d4-flavor-prdouct-img');
            img.setAttribute('src', product.img);
            elm.appendChild(img);
            const info = document.createElement('div');
            info.classList.add('d4-free-product-info');
            const title = document.createElement('h3');
            const text = document.createElement('h3');
            title.textContent = product.title;
            text.textContent = 'Free With Your First Order';
            info.appendChild(title);
            info.appendChild(text);
            /* Price with compare/scratch price */
            if(product.price) {
                const priceWrap = document.createElement('div');
                priceWrap.classList.add('d4-free-product-prices');
                const currentPrice = document.createElement('span');
                currentPrice.classList.add('d4-free-product-price');
                currentPrice.textContent = product.price;
                priceWrap.appendChild(currentPrice);
                if(product.compare_price && product.compare_price !== product.price) {
                    const comparePrice = document.createElement('span');
                    comparePrice.classList.add('d4-free-product-compare-price');
                    comparePrice.textContent = product.compare_price;
                    priceWrap.appendChild(comparePrice);
                }
                info.appendChild(priceWrap);
            }
            elm.appendChild(info);
            const freetagdiv = document.createElement('div');
            freetagdiv.classList.add('d4-bundle-free-tag');
            const freetag = document.createElement('h4');
            freetag.textContent = 'FREE';
            freetag.classList.add('d4-bundle-free-tag');
            freetagdiv.appendChild(freetag);
            elm.appendChild(freetagdiv);
            mainBundle.appendChild(elm);
            console.log(elm, mainBundle)
            }
        };
    }


    //Function to Handle main bundle functionality
    window.d4HandleBundle = function() {
        const productAddBtns = document.querySelectorAll('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-products .d4-flavor-product .d4-flavor-product-btn');
        //const mainBundle = document.querySelector('.d4-custom-bundle-container .d4-bundle-flavors .d4-flavor-bundle .d4-flavor-bundle-body');

        for(btn of productAddBtns) {
            btn.addEventListener('click', (e) => {
                d4UpdateBundle(e.target.closest('.d4-flavor-product'));
            })
        }

        //check local storage key exists
        if(localStorage.getItem('d4SavedItems')?.length > 2) {
            const savedItems = localStorage.getItem('d4SavedItems');
            const savedItemsArray = JSON.parse(savedItems);
            savedItemsArray.forEach(item => {
                const { outerhtml } = item;
                const html = new DOMParser().parseFromString(outerhtml, 'text/html');
                const elm = html.body.firstChild;
                mainBundle.appendChild(elm);
                d4HandleBundleProduct(elm);
                d4SaveBundleProducts(elm, null);
                const filterProduct = document.querySelector(`.d4-custom-bundle-container .d4-flavor-container .d4-flavor-products .d4-flavor-product[data-product-id="${elm.dataset.bundledId}"]`);
                const quantity = filterProduct.querySelector('.d4-flavor-product-quantity');
                const btn = filterProduct.querySelector('.d4-flavor-product-btn');
                let updatedQuantity = filterProduct.querySelector('.d4-flavor-product-quantity span');
                updatedQuantity.textContent = elm.querySelector('.d4-flavor-product-quantity span').textContent;
                quantity.classList.remove('d4-flavor-hidden');
                btn.classList.add('d4-flavor-hidden');
                filterProduct.classList.add('d4-product-selected');
            })
        }

        window.d4UpdateBundle = function(elm, elmqnt) {
            const elmQuantity = elm.querySelector('.d4-flavor-product-quantity');
            const elmBtn = elm.querySelector('.d4-flavor-product-btn');
            elmQuantity.classList.remove('d4-flavor-hidden');
            elmBtn.classList.add('d4-flavor-hidden');
            elm.classList.add('d4-product-selected');

            const newElm = document.createElement('div');
            const newElmInfo = document.createElement('div');
            const newElmInfoLink = document.createElement('div');
            const newElmInfoBtn = document.createElement('button');
            newElmInfoBtn.textContent = 'Remove Item';
            newElm.setAttribute('data-bundled-id', elm.dataset.productId);
            newElm.classList.add('d4-flavor-product-bundled');
            newElmInfo.classList.add('d4-flavor-bundled-info');
            newElmInfoLink.classList.add('d4-flavor-bundled-info-link');
            const img = elm.querySelector('.d4-flavor-prdouct-img').cloneNode(true);
            const name = elm.querySelector('.d4-flavor-product-info h3').cloneNode(true);
            const quantity = elm.querySelector('.d4-flavor-product-quantity').cloneNode(true);
            if(elmqnt !== null && elmqnt !== undefined) {
                quantity.querySelector('span').textContent = elmqnt;
                elm.querySelector('.d4-flavor-product-quantity span').textContent = elmqnt;
            }
            quantity.querySelectorAll('button').forEach(button => {
                button.setAttribute('data-bundle-quantity', 'true');
            });
            //adding new product to the sticky bundle
            newElm.appendChild(img);
            newElm.appendChild(newElmInfo);
            newElmInfo.appendChild(newElmInfoLink);
            newElmInfoLink.appendChild(name);
            newElmInfoLink.appendChild(newElmInfoBtn);
            newElmInfo.appendChild(quantity);
            mainBundle.appendChild(newElm);
            d4HandleBundleProduct(newElm);
            d4SaveBundleProducts(newElm, null);
            d4HandleProgress();
        };
    };

    //Function to handle quantity changes & add/remove product into bundle
    const d4HandleBundleProduct = (elm) => {
        let filterProduct = document.querySelector(`.d4-custom-bundle-container .d4-flavor-container .d4-flavor-products .d4-flavor-product[data-product-id="${elm.dataset.bundledId}"]`);
        const filterProductQuantities = filterProduct.querySelectorAll('.d4-flavor-product-quantity button');
        const elmQuantities = elm.querySelectorAll('.d4-flavor-product-quantity button');
        //handle remove button click
        elm.querySelector('.d4-flavor-bundled-info-link button').addEventListener('click', d4RemoveProduct);
        //use to remove element from sticky bundle
        function d4RemoveProduct() {
            filterProduct.querySelector('.d4-flavor-product-btn').classList.remove('d4-flavor-hidden');
            filterProduct.querySelector('.d4-flavor-product-quantity').classList.add('d4-flavor-hidden');
            filterProduct.classList.remove('d4-product-selected');
            const filterQuantity = filterProduct.querySelector('.d4-flavor-product-quantity span');
            //const BundledQuantity = elm.querySelector('.d4-flavor-product-quantity span');
            filterQuantity.textContent = '1';
            //BundledQuantity.textContent = '1';
            filterProductQuantities.forEach(quantity => {
                quantity.removeEventListener('click', d4HandleProductListener);
            })
            d4SaveBundleProducts(null, elm);
            elm.remove();
            d4HandleProgress();
        }

        function d4HandleProductListener(e) {
            if(e.target.classList.contains('d4-bundle-full')) {
                return
            } else {
                d4HandleBundleQuantityChange(e.target);
                d4HandleProgress();
            }
        }

        for(quantityBtn of filterProductQuantities) {
            quantityBtn.addEventListener('click', d4HandleProductListener)
        }

        for(quantityBtn of elmQuantities) {
            quantityBtn.addEventListener('click', d4HandleProductListener)
        }


        //Handle quantity update + remove product conditionaly
        function d4HandleBundleQuantityChange(btn) {
            const filterQuantity = filterProduct.querySelector('.d4-flavor-product-quantity span');
            const bundleQuantity = elm.querySelector('.d4-flavor-product-quantity span');
                if(btn.dataset.action === 'plus') {
                    filterQuantity.textContent = Number(filterQuantity.textContent) + 1;
                    bundleQuantity.textContent = Number(bundleQuantity.textContent) + 1;
                    d4SaveBundleProducts(elm, null);
                } else {
                    if(filterQuantity.textContent === '1') {
                        d4RemoveProduct();
                    } else {
                        filterQuantity.textContent = Number(filterQuantity.textContent) - 1;
                        bundleQuantity.textContent = Number(bundleQuantity.textContent) - 1;
                        d4SaveBundleProducts(elm, null);
                    }
                }
        }
    };


    //Function to save the last added bundle products
    const d4SaveBundleProducts = (addProduct, removeProduct) => {
        if(removeProduct === null || removeProduct === undefined) {
            const addProductIndex = d4SavedItems.indexOf(addProduct);
            if(addProductIndex !== -1 && addProductIndex !== null) {
                d4SavedItems[addProductIndex] = addProduct;
            } else {
                d4SavedItems.push(addProduct);
            }
        } else if(addProduct === null || addProduct === undefined) {
            const removeProductIndex = d4SavedItems.indexOf(removeProduct);
            if(removeProductIndex !== -1) {
                d4SavedItems.splice(removeProductIndex, 1);
            }
        }

        const d4SavedItemsArray = [];
        d4SavedItems.forEach(item => {
            d4SavedItemsArray.push({outerhtml: item.outerHTML})
        })
        const d4SavedItemsJson = JSON.stringify(d4SavedItemsArray);
        localStorage.setItem('d4SavedItems', d4SavedItemsJson);
    };




    //Function to handle progress bar and checkout (3-checkpoint version)
    const d4HandleProgress = () => {
        const progressBar = document.querySelector('.d4-custom-bundle-container .d4-bundle-body .d4-flavor-bundle .d4-flavor-bundle-bar');

        // Calculate totalLength first (needed for both desktop and mobile)
        let totalLength = 0;
        const mainBundleProductsQuantity = mainBundle.querySelectorAll('.d4-flavor-product-bundled .d4-flavor-product-quantity span');
        mainBundleProductsQuantity.forEach(quantity => {
            totalLength += Number(quantity.textContent) || 0;
        });

        // Sync mobile progress bar (always runs, even when desktop bar is hidden)
        const mobileBar = document.querySelector('.d4-mobile-progress-bar');
        if (mobileBar) {
            const mCp1 = Number(mobileBar.dataset.cp1) || 6;
            const mCp2 = Number(mobileBar.dataset.cp2) || 9;
            const mCp3 = Number(mobileBar.dataset.cp3) || 15;
            const mFill = mobileBar.querySelector('.d4-mobile-progress-fill');
            const mTracker = mobileBar.querySelector('.d4-mobile-cp-tracker');
            const mCp1El = mobileBar.querySelector('.d4-mobile-cp1');
            const mCp2El = mobileBar.querySelector('.d4-mobile-cp2');
            const mCp3El = mobileBar.querySelector('.d4-mobile-cp3');

            let mPct = 0;
            if (totalLength <= 0) { mPct = 0; }
            else if (totalLength <= mCp1) { mPct = (totalLength / mCp1) * 33.33; }
            else if (totalLength <= mCp2) { mPct = 33.33 + ((totalLength - mCp1) / (mCp2 - mCp1)) * 33.33; }
            else if (totalLength <= mCp3) { mPct = 66.66 + ((totalLength - mCp2) / (mCp3 - mCp2)) * 33.34; }
            else { mPct = 100; }

            if (mFill) {
                const mTrackEl = mobileBar.querySelector('.d4-mobile-progress-track');
                if (mTrackEl && mTrackEl.offsetWidth) {
                    mFill.style.width = ((mPct / 100) * mTrackEl.offsetWidth) + 'px';
                } else {
                    mFill.style.width = mPct + '%';
                }
            }
            if (mTracker) {
                mTracker.textContent = totalLength;
                mTracker.style.left = mPct + '%';
                mTracker.classList.toggle('at-zero', totalLength === 0);
            }
            if (mCp1El) { mCp1El.classList.toggle('cp-reached', totalLength >= mCp1); mCp1El.style.opacity = totalLength === mCp1 ? '0' : '1'; }
            if (mCp2El) { mCp2El.classList.toggle('cp-reached', totalLength >= mCp2); mCp2El.style.opacity = totalLength === mCp2 ? '0' : '1'; }
            if (mCp3El) { mCp3El.classList.toggle('cp-reached', totalLength >= mCp3); mCp3El.style.opacity = totalLength === mCp3 ? '0' : '1'; }
        }

        // Get max value from mobile bar data or fallback
        const globalCp1 = (mobileBar && Number(mobileBar.dataset.cp1)) || 6;
        const globalCp2 = (mobileBar && Number(mobileBar.dataset.cp2)) || 9;
        const globalCp3 = (mobileBar && Number(mobileBar.dataset.cp3)) || 15;
        const globalMax = globalCp3;

        // Update checkout btn (always runs - works on both desktop and mobile)
        if(totalLength < globalCp1) {
            // Before checkpoint 1
            checkoutBtnLabel.textContent = checkoutBtnLabelMin;
            mobileBtnLabel.textContent = checkoutBtnLabelMin;
            checkoutBtn.classList.remove('d4-flavor-checkout-ready');
            mobileBtn.classList.remove('d4-bundle-mobile-btn-ready');
            checkoutBtnQuantity.style.display = 'flex';
            mobileBtnQuantity.style.display = 'flex';
        } else if(totalLength === globalCp1) {
            // At checkpoint 1
            checkoutBtnLabel.textContent = checkoutBtnLabelText;
            mobileBtnLabel.textContent = checkoutBtnLabelText;
            checkoutBtn.classList.add('d4-flavor-checkout-ready');
            mobileBtn.classList.add('d4-bundle-mobile-btn-ready');
            checkoutBtnQuantity.style.display = 'none';
        } else if(totalLength > globalCp1 && totalLength < globalCp2) {
            // Between checkpoint 1 & 2
            checkoutBtnLabel.textContent = checkoutBtnLabelText16;
            mobileBtnLabel.textContent = checkoutBtnLabelText16;
            checkoutBtn.classList.remove('d4-flavor-checkout-ready');
            mobileBtn.classList.remove('d4-bundle-mobile-btn-ready');
            checkoutBtnQuantity.style.display = 'flex';
            mobileBtnQuantity.style.display = 'flex';
        } else if(totalLength === globalCp2) {
            // At checkpoint 2
            checkoutBtnLabel.textContent = checkoutBtnLabelText24;
            mobileBtnLabel.textContent = checkoutBtnLabelText24;
            checkoutBtn.classList.add('d4-flavor-checkout-ready');
            mobileBtn.classList.add('d4-bundle-mobile-btn-ready');
            checkoutBtnQuantity.style.display = 'none';
        } else if(totalLength > globalCp2 && totalLength < globalCp3) {
            // Between checkpoint 2 & 3
            checkoutBtnLabel.textContent = checkoutBtnLabelBetweenCp2Cp3;
            mobileBtnLabel.textContent = checkoutBtnLabelBetweenCp2Cp3;
            checkoutBtn.classList.remove('d4-flavor-checkout-ready');
            mobileBtn.classList.remove('d4-bundle-mobile-btn-ready');
            checkoutBtnQuantity.style.display = 'flex';
            mobileBtnQuantity.style.display = 'flex';
        } else if(totalLength >= globalCp3) {
            // At checkpoint 3 (max)
            checkoutBtnLabel.textContent = checkoutBtnLabelCp3;
            mobileBtnLabel.textContent = checkoutBtnLabelCp3;
            checkoutBtnQuantity.style.display = 'none';
            checkoutBtn.classList.add('d4-flavor-checkout-ready');
            mobileBtn.classList.add('d4-bundle-mobile-btn-ready');
        }
        checkoutBtnQuantity.textContent = totalLength;
        mobileBtnQuantity.textContent = totalLength;

        // Lock bundle and products when it reaches the max limit (always runs)
        const bundleAndFilterProductsInfo = document.querySelectorAll('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-product,.d4-custom-bundle-container .d4-flavor-container .d4-flavor-product-bundled');
        if(totalLength >= globalMax) {
            bundleAndFilterProductsInfo.forEach(product => {
                if(product.querySelector('.d4-flavor-product-btn')) {
                    product.querySelector('.d4-flavor-product-btn').textContent = fullBoxMsg;
                    product.querySelector('.d4-flavor-product-btn').classList.add('d4-bundle-full');
                }
                product.querySelector('.d4-flavor-product-quantity button[data-action="plus"]').classList.add('d4-bundle-full');
            })
        } else {
            bundleAndFilterProductsInfo.forEach(product => {
                if(product.querySelector('.d4-flavor-product-btn')) {
                    product.querySelector('.d4-flavor-product-btn').textContent = '+ Add';
                    product.querySelector('.d4-flavor-product-btn').classList.remove('d4-bundle-full');
                }
                product.querySelector('.d4-flavor-product-quantity button[data-action="plus"]').classList.remove('d4-bundle-full');
            })
        }

        // Empty state
        if(totalLength === 0) {
            mainBundleEmpty.classList.remove('d4-flavor-bundle-hide');
            const bundledfreeProductEarly = mainBundle.querySelectorAll('.d4-free-product-bundled');
            bundledfreeProductEarly?.forEach(product => product.remove());
            freeProductFunctionCalled = false;
        } else {
            mainBundleEmpty.classList.add('d4-flavor-bundle-hide');
        }

        // Free product at checkpoint logic
        if(bundleContainer.hasAttribute('data-d4-bundle-free-product') && typeof d4HandleFreeProduct === 'function') {
            const freeCp1 = bundleContainer.dataset.freeCp1 === 'true';
            const freeCp2 = bundleContainer.dataset.freeCp2 === 'true';
            const freeCp3 = bundleContainer.dataset.freeCp3 === 'true';
            const existingFree = mainBundle.querySelector('.d4-free-product-bundled');

            // Determine if free product should show based on which checkpoints are hit
            let showFree = false;
            if(freeCp1 && totalLength >= globalCp1) showFree = true;
            if(freeCp2 && totalLength >= globalCp2) showFree = true;
            if(freeCp3 && totalLength >= globalCp3) showFree = true;
            if(totalLength === 0) showFree = false;

            if(showFree && !existingFree) {
                d4HandleFreeProduct();
                freeProductFunctionCalled = true;
            } else if(!showFree && existingFree) {
                mainBundle.querySelectorAll('.d4-free-product-bundled').forEach(p => p.remove());
                freeProductFunctionCalled = false;

                // Auto-remove free product from cart when user drops below threshold
                if(!d4IsCheckingOut && typeof freeProducts !== 'undefined' && freeProducts && freeProducts.length > 0) {
                    fetch('/cart.js')
                        .then(r => r.json())
                        .then(cart => {
                            const freeIds = freeProducts.map(p => String(p.id));
                            cart.items.forEach(item => {
                                if(freeIds.includes(String(item.variant_id))) {
                                    fetch('/cart/change.js', {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ id: String(item.variant_id), quantity: 0 })
                                    }).then(() => {
                                        console.log('Free product auto-removed from cart');
                                        // Trigger cart UI refresh if available
                                        document.dispatchEvent(new CustomEvent('cart:updated'));
                                    });
                                }
                            });
                        });
                }
            }
        }

        // Desktop progress bar (may be hidden on mobile)
        if (!progressBar) return;
        const progressBarWidth = progressBar.offsetWidth;
        if (!progressBarWidth) return;
        const progressBarPointerDiv = progressBar.querySelector('.d4-flavor-bundle-progress-bar');
        const progressBarPointer = progressBar.querySelector('.d4-flavor-bundle-bar-custom');
        if (!progressBarPointerDiv || !progressBarPointer) return;

        // Read 3 checkpoints from data attributes, fallback to old min/max elements
        const cp1Val = Number(progressBar.dataset.cp1) || Number((progressBar.querySelector('.d4-flavor-bundle-bar-min') || {}).textContent) || 6;
        const cp2Val = Number(progressBar.dataset.cp2) || Number((progressBar.querySelector('.d4-flavor-bundle-bar-max') || {}).textContent) || 9;
        const cp3Val = Number(progressBar.dataset.cp3) || 15;
        const maxVal = cp3Val; // The absolute max is checkpoint 3

        const cp1El = progressBar.querySelector('.d4-flavor-bundle-bar-cp1');
        const cp2El = progressBar.querySelector('.d4-flavor-bundle-bar-cp2');
        const cp3El = progressBar.querySelector('.d4-flavor-bundle-bar-cp3');

        // Desktop visual bar updates only
        if(totalLength >= cp1Val) {
            progressBarPointerDiv.classList.add('d4-progress-bar-min');
        } else {
            progressBarPointerDiv.classList.remove('d4-progress-bar-min');
        }

        let pct = 0;
        if (totalLength <= 0) { pct = 0; }
        else if (totalLength <= cp1Val) { pct = (totalLength / cp1Val) * 33.33; }
        else if (totalLength <= cp2Val) { pct = 33.33 + ((totalLength - cp1Val) / (cp2Val - cp1Val)) * 33.33; }
        else if (totalLength <= cp3Val) { pct = 66.66 + ((totalLength - cp2Val) / (cp3Val - cp2Val)) * 33.34; }
        else { pct = 100; }

        const pointerPos = (pct / 100) * progressBarWidth;
        progressBarPointer.style.left = `${pointerPos - 1}px`;
        progressBarPointerDiv.style.width = `${pointerPos + 12}px`;
        progressBarPointer.textContent = totalLength;

        if (cp1El) { cp1El.classList.toggle('cp-reached', totalLength >= cp1Val); cp1El.style.opacity = totalLength === cp1Val ? '0' : '1'; }
        if (cp2El) { cp2El.classList.toggle('cp-reached', totalLength >= cp2Val); cp2El.style.opacity = totalLength === cp2Val ? '0' : '1'; }
        if (cp3El) { cp3El.classList.toggle('cp-reached', totalLength >= cp3Val); cp3El.style.opacity = totalLength === cp3Val ? '0' : '1'; }
    };



    const d4HandleCheckout = () => {
        checkoutBtn.addEventListener('click', () => {
            if(checkoutBtn.classList.contains('d4-flavor-checkout-ready')) {
                let productIds = [];

                // Add free products only if they're currently showing in the bundle
                const currentFreeProducts = mainBundle.querySelectorAll('.d4-free-product-bundled');
                if(currentFreeProducts.length > 0 && typeof freeProducts !== 'undefined' && freeProducts) {
                    for(product of freeProducts) {
                        productIds.push({id: product.id, quantity: '1'});
                    }
                }

                // Add bundled products
                const bundledProducts = mainBundle.querySelectorAll('.d4-flavor-product-bundled');
                for(product of bundledProducts) {
                    productIds.push({id: product.dataset.bundledId, quantity: product.querySelector('.d4-flavor-product-quantity span').textContent});
                }

                let formData = {
                    'items': productIds.map(product => ({
                      'id': product.id,
                      'quantity': product.quantity
                    }))
                };

                d4IsCheckingOut = true; // Block auto-remove during checkout

                // Store free product IDs in sessionStorage so cart can re-add if user returns to 11+
                // This only exists if user came through build-a-box — never set on manual cart adds
                if(typeof freeProducts !== 'undefined' && freeProducts && freeProducts.length > 0) {
                    sessionStorage.setItem('d4BundleFreeIds', JSON.stringify(freeProducts.map(p => String(p.id))));
                }
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    console.log('products added')
                    d4ClearBundle();
                    mainBundle.querySelectorAll('.d4-free-product-bundled')?.forEach(product => product.remove());
                    window.location.pathname = 'cart/checkout';
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
        })
    };



    //Function to clear products from bundle
    const d4ClearBundle = () => {
        const bundledItems = document.querySelectorAll('.d4-custom-bundle-container .d4-bundle-flavors .d4-flavor-bundle .d4-flavor-bundle-body .d4-flavor-product-bundled');
        bundledItems.forEach(bundledItem => {
            bundledItem.querySelector('button').click();
        })
        d4SavedItems = [];
        d4HandleProgress();
    };



    //Function to handle the flavor tags and update bundle
    const d4CustomBundleObject = () => {
        let tagProductsId;
        const flavorBtns = document.querySelectorAll('.d4-custom-bundle-container .d4-flavor-tags .d4-flavor-tag');
        for(btn of flavorBtns) {
            btn.addEventListener('click', (e) => {
                mainBundle.querySelector('.d4-free-product-bundled')?.remove();
                freeProductFunctionCalled = false;
                d4HandleTagsClick(e.target.textContent);

                // Open Bundle Drawer on Mobile
                if(window.innerWidth <= 768) {
                    mobileBtn.dispatchEvent(new Event('click'));
                    const scrollDiv = document.querySelector('.d4-custom-bundle-container .d4-flavor-container').offsetTop;
                    window.scrollTo({top: scrollDiv, behavior: "smooth"});
                }
            })
        }

        //Function to collect all the products related to clicked tag
        const d4HandleTagsClick = (currentTag) => {
            tagProductsId = bundleFlavors.filter(flavor => {
               return flavor.hasOwnProperty(`${currentTag}`) 
            }).map(flavor => flavor[`${currentTag}`]);

            //get the selected option vlaue
            const selectedOption = document.querySelector('.d4-custom-bundle-container .d4-options .d4-option-selected');
            const quantityLimit = Number(selectedOption.dataset.sizeOption);
            console.log('limit:', quantityLimit, ' products:', tagProductsId)

            d4ClearBundle();
            freeProductFunctionCalled = false;
            tagProductsId.forEach(productId => {
                const productElm = document.querySelector(`.d4-custom-bundle-container .d4-flavor-products-container .d4-flavor-product[data-product-id="${productId}"]`);
                console.log('its product:',productElm)
                if(quantityLimit === 16) {
                    window.d4UpdateBundle(productElm, productElm.getAttribute(`data-bundle-${currentTag.split(' ')[0].toLowerCase()}-quantity16`));
                    console.log('dataset 16:', productElm.getAttribute(`data-bundle-${currentTag.split(' ')[0].toLowerCase()}-quantity16`))
                } else if(quantityLimit === 24) {
                    window.d4UpdateBundle(productElm, productElm.getAttribute(`data-bundle-${currentTag.split(' ')[0].toLowerCase()}-quantity24`));
                    console.log('dataset 24:', productElm.getAttribute(`data-bundle-${currentTag.split(' ')[0].toLowerCase()}-quantity24`))
                }
            })
        }
    };



    //Function to handle Mobile btn
    const d4BundleMobile = () => {
        if(window.innerWidth <= 768) {
            const bgDiv = document.querySelector('.d4-custom-bundle-container .d4-bundle-body .d4-flavor-container .d4-flavor-products-container');
            const bundle = document.querySelector('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-bundle .d4-flavor-bundle-body');
            const announcement = document.querySelector('.announcement-bar-section').offsetHeight;
            const stickyHeader = document.querySelector('.section-header').offsetHeight;
            const viewportTop = announcement + stickyHeader;
            mobileBtn.addEventListener('click', () => {
                mobileBundle.classList.add('d4-flavor-bundle-mobile-visible');
                mobileBtn.closest('.d4-bundle-mobile').classList.add('d4-flavor-mobile-hide');
                d4HandleProgress();
                bundle.style.maxHeight = `calc(${window.innerHeight}px - ${viewportTop}px - 170px)`;
                bundle.style.minHeight = `calc(${window.innerHeight}px - ${viewportTop}px - 170px)`;
                bgDiv.style.background = 'rgb(0,0,0, 0.5)';
                bgDiv.style.filter = 'brightness(0.5)';
                document.body.classList.add('overflow-hidden-tablet');
                document.body.style.overflow = 'hidden';
                bgDiv.querySelector('.d4-flavor-products').style.pointerEvents = 'none';
                bgDiv.addEventListener('click', () => {
                    mobileCloseBtn.dispatchEvent(new Event('click'));
                })
            });

            mobileCloseBtn.addEventListener('click', () => {
                mobileBundle.classList.remove('d4-flavor-bundle-mobile-visible');
                mobileBtn.closest('.d4-bundle-mobile').classList.remove('d4-flavor-mobile-hide');
                bgDiv.style.background = 'none';
                bgDiv.style.filter = 'brightness(1)';
                document.body.classList.remove('overflow-hidden-tablet');
                document.body.removeAttribute('style');
                bgDiv.querySelector('.d4-flavor-products').style.pointerEvents = 'all';
            })
        }
    };

    //Media query listener to update progress bar on mobile
    if(window.innerWidth <= 768) {
        window.addEventListener('resize', d4HandleProgress);
    }


    d4LoadbundleObject();
    if (bundleContainer.hasAttribute('data-d4-bundle-free-product')) d4LoadFreeProducts();
    d4CustomBundleObject();
    d4HandleBundleVariants();
    d4HandleFilterChanges();
    d4HandleBundle();
    d4HandleProgress();
    d4HandleCheckout();
    d4BundleMobile();
});